export const environment = {
  production: true,
  API: 'https://api-isc.pw-bs.com',
  MEDIA_URL: 'https://d3beg4yhk9qz07.cloudfront.net/'
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts